import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { TeamForm } from "./-components/form/team-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/teams/create",
)({
  staticData: { breadcrumb: "New team" },
  component: CreateTeamPage,
})

function CreateTeamPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="New team" />
      <Card className="p-4 shadow-none">
        <TeamForm
          onCreate={(created) => {
            showToast("Created", `${created.name} added.`, "success")
            navigate({ to: "/settings/workspace/teams" })
          }}
        />
      </Card>
    </PageContent>
  )
}
